import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getMemberships, PassCategory } from "src/api/membership";
const useMembershipQuery = (param)=>{
    let { productId , isLoggedIn , freepassOnly , selectedPurchaseOption  } = param;
    return useQuery([
        "ticketList",
        productId,
        selectedPurchaseOption
    ], ()=>{
        return getMemberships({
            productId: String(productId),
            category: freepassOnly ? [
                PassCategory.FreePass
            ] : [
                PassCategory.Solvookplus,
                PassCategory.Subscription,
                PassCategory.Ticket
            ],
            purchaseOption: selectedPurchaseOption
        });
    }, {
        keepPreviousData: true,
        enabled: isLoggedIn,
        select: (data)=>{
            return data.unexpired.map((ticket)=>{
                var _ticket_remainAmount;
                if (!ticket.usable) {
                    return {
                        id: ticket.membershipId,
                        title: ticket.productInfo.title,
                        detailText: "사용범위에 맞지 않는 자료",
                        isDisabled: true,
                        raw: ticket
                    };
                }
                const isUnlimitedUse = freepassOnly || ticket.productInfo.category === "solvookplus" || ticket.productInfo.category === "solvookplus-subscribe";
                const isRemainUsablePass = ticket.deductionMethod === "count" ? ticket.remainCount : ticket.remainAmount;
                if (!isUnlimitedUse && !isRemainUsablePass) {
                    return {
                        id: ticket.membershipId,
                        title: ticket.productInfo.title,
                        detailText: "사용완료",
                        isDisabled: true,
                        raw: ticket
                    };
                }
                var _ticket_remainAmount_toLocaleString;
                return {
                    id: ticket.membershipId,
                    title: ticket.productInfo.title,
                    detailText: isUnlimitedUse ? "사용범위 내 무제한" : ticket.deductionMethod === "count" ? "".concat(ticket.remainCount, "회") : "".concat((_ticket_remainAmount_toLocaleString = (_ticket_remainAmount = ticket.remainAmount) === null || _ticket_remainAmount === void 0 ? void 0 : _ticket_remainAmount.toLocaleString()) !== null && _ticket_remainAmount_toLocaleString !== void 0 ? _ticket_remainAmount_toLocaleString : 0, "원"),
                    remainDay: ticket.remainDay,
                    isDisabled: false,
                    raw: ticket
                };
            });
        }
    });
};
export const useInvalidateMembershipQuery = ()=>{
    const queryClient = useQueryClient();
    return (productId)=>{
        queryClient.invalidateQueries({
            queryKey: [
                "ticketList",
                productId
            ]
        });
    };
};
export default useMembershipQuery;
